"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ServerError = void 0;
const ResponseError_1 = require("./ResponseError");
class ServerError extends ResponseError_1.ResponseError {
    constructor(options) {
        super(options);
        this.name = this.constructor.name;
        this.message = this.message || ServerError.label;
        this.type = ServerError.type;
        this.statusCode = ServerError.statusCode;
        Error.captureStackTrace(this, ServerError);
    }
}
exports.ServerError = ServerError;
ServerError.type = 'ServerError';
ServerError.label = 'Internal Server Error';
ServerError.statusCode = 500;
//# sourceMappingURL=ServerError.js.map